// Only finite backend reason codes select provider diagnostics. Never display
// provider text, guess consent, or suggest a fresh key for a rejected send.
const messages = new Map([
  ['recipient_unsubscribed', 'The SMS provider rejected this message because the recipient has unsubscribed.'],
  ['invalid_recipient', 'The SMS provider rejected this message because the recipient number is invalid. Check the saved number.'],
  ['invalid_recipient_country_code', 'The SMS provider rejected this message because the number or country code is unsupported. Check the saved number and country code.'],
  ['provider_insufficient_credit', 'The SMS provider rejected this message because the provider account has insufficient credit. Contact the salon administrator.'],
  ['provider_authentication_failed', 'The SMS provider rejected this message because the provider account could not be authenticated. Contact the salon administrator.'],
]);

export const chatRejectionMessage = action => {
  const error = action?.payload?.message?.error;
  if (error?.code !== 'provider_rejected') return null;
  return messages.get(error.reason)
    || 'The SMS provider rejected this message. The reason is unavailable. Contact the salon administrator.';
};
